import React, { useRef } from 'react';
import IdleTimer from 'react-idle-timer';
import { useHistory } from 'react-router-dom';
import { PAGE_URLS, ANALYTICS_EVENTS, TIMEOUTS } from '@constants';
import { usePresentation } from '@context/presentation';
import { updateAnalytics } from '@services/analytics';
import { createAnalyticsEventBody } from '@utils/analytics';

export const IdleTimerContainer = () => {
    const idleTimerRef = useRef(null);
    const history = useHistory();
    const { clientViewing, client: clientData, presentationId } = usePresentation();
    const { leadId } = clientData;

    const { CLIENT_TIMEOUT, REP_TIMEOUT } = PAGE_URLS;
    const { client, salesRep } = TIMEOUTS;

    const redirectUrl = clientViewing ? CLIENT_TIMEOUT : REP_TIMEOUT;
    const idleTimeout = clientViewing ? client : salesRep;

    const handleOnIdle = async () => {
      const { sessionEnded } = ANALYTICS_EVENTS;
    
      await updateAnalytics(createAnalyticsEventBody(presentationId, sessionEnded));
      
      history.push({
          pathname: redirectUrl,
          state: { leadId }
        });
    };
  
    return (
        <IdleTimer
          ref={idleTimerRef} 
          timeout={idleTimeout}
          onIdle={handleOnIdle}
        />
    );
};

export default IdleTimerContainer;
